import { FC, PropsWithChildren, type JSX } from 'react';
import PageWrapper from '../pageWrapper/PageWrapper';
import PayacaLogo from './payaca-logo.svg';

import './BasicPageWrapper.sass';

type Props = {
  className?: string;
};
const BasicPageWrapper: FC<PropsWithChildren<Props>> = ({
  className,
  children,
}: PropsWithChildren<Props>): JSX.Element => {
  return (
    <PageWrapper className={`basic-page-wrapper ${className ? className : ''}`}>
      <div className="page-content">
        <div className="header-content">
          <img src={PayacaLogo} alt="Payaca logo" className="w-[150px]" />
        </div>
        <div className="body-content">{children}</div>
      </div>
    </PageWrapper>
  );
};

export default BasicPageWrapper;
